import { Component, OnInit, Input } from '@angular/core';
import { NgbNavChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { CustomTabService } from '@custom/modules/gen/custom-tab/custom-tab.service';
import { AppConstants } from '@custom/core/app-constants';

@Component({
  selector: 'vs-step-forms',
  templateUrl: './step-forms.component.html',
  styleUrls: ['./step-forms.component.scss']
})
export class StepFormsComponent implements OnInit {

  @Input() stepConfig: any = {};
  isMobile: boolean;
  activeTab: string;
  @Input() data: any = {};
  formConfig: {};
  stepforms: any;
  constructor(private customTab: CustomTabService) { }

  onNavChange(event: NgbNavChangeEvent) {
    console.log('tab changed');
    this.customTab.handleTabChange(event);
  }

  public makeFormConfig(item) {
    item[0].type = "steps"
    let config = {
      collapsible: false,
      submit: 'saveBasicDetails1',
      class: 'no-margin form-elements-group',
      disabledForm: false,
      columns: 100,
      groups: [
        {
          groupHeaderClass: 'hidden hidden',
          groupContentClass: 'paddingZero',
          collapsible: 'false',
          columns: '0',
          label: '',
          disableRights: false,
          columnsWidth: 12,
          type: "steps",
          items: item
        }
      ]
    }
    return config;
  }

  ngOnInit() {
    this.isMobile = AppConstants.isMobile;
    if (this.stepConfig && this.stepConfig.legnth > 0) {
      this.stepforms.forEach((step) => {
        step.items = this.makeFormConfig(step.items);
      });
    }
  }
}
